import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { UserSession } from '../../shared/user-session';


@Component({
    //templateUrl: 'app/system-management/staffing-standards/staffing-standards.component.html',
    template: require('./staffing-standards.component.html'),
    directives: [ROUTER_DIRECTIVES],
})

export class StaffingStandardsComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Staffing Standards';
    errorMessage: string;
    scenario: number;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private User: UserSession) {
                    
    }

    ngOnInit(): void{
       this.scenario = this.User.getSession().scenarioId;
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/staffing-standards/staffing-standards.component.ts
 **/